import {
  DEFAULT_TEXT_LABEL_FONT_SIZE,
  MAX_TEXT_LABEL_FONT_SIZE,
  MIN_TEXT_LABEL_FONT_SIZE
} from "~/features/andon/andon.types";

export function clampTextLabelFontSize(value: number): number {
  return Math.min(
    MAX_TEXT_LABEL_FONT_SIZE,
    Math.max(MIN_TEXT_LABEL_FONT_SIZE, Math.round(value))
  );
}

export function computeTextLabelFontSizePx(
  fontSize: number | undefined,
  boardScale: number
): number {
  return (fontSize ?? DEFAULT_TEXT_LABEL_FONT_SIZE) * boardScale;
}
